import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "its-client" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "topbar", {}, undefined, true),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          class: "fill-height pa-0 ma-0",
          fluid: ""
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "main", {}, undefined, true)
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    _renderSlot(_ctx.$slots, "footer", {}, undefined, true),
    _createVNode(_component_Modal, { show: _ctx.showModal }, null, 8, ["show"])
  ]))
}